export const Classes =
{
    // desktop
    menuSource: "skywardMainMenu__menuSource",
    menu: "skywardMainMenu__menuPanel",
    menuClosed: "skywardMainMenu__menuPanel--closed",
    menuOpen: "skywardMainMenu__menuPanel--open",
    menuTransitioning: "skywardMainMenu__menuPanel--transitioning",
    portalBar: "skywardMainMenu__portalBar",
    portalButton: "skywardMainMenu__portalButton",
    currentPortalButton: "skywardMainMenu__portalButton--selected",
    portalButtonTextContainer: "portalButton__textContainer",
    portalButtonText: "portalButton__text",
    portalContent: "skywardMainMenu__portalContent",
    moduleContainer: "skywardMainMenu__moduleContainer",
    moduleListItem: "skywardMainMenu__moduleListItem",
    moduleButton: "skywardMainMenu__moduleButton",
    moduleButtonText: "skywardMainMenu__moduleText",
    moduleButtonSvg: "menuModuleSvg",
    moduleButtonSelected: "skywardMainMenu__moduleButton--selected",
    moduleScreens: "skywardMainMenu__moduleScreens",
    moduleScreensContainer: "skywardMainMenu__moduleScreensContainer",
    centerPanel: "moduleScreens__centerPanel",
    centerPanelCategory: "moduleScreens__centerPanelCategory",
    centerPanelScreen: "moduleScreens__centerPanelScreen",
    centerPanelScreenSelected: "moduleScreens__centerPanelScreen--selected",
    centerPanelScreenText: "moduleScreens__centerPanelScreenText",
    centerPanelCategoryListItem: "moduleScreens__centerPanelCategoryListItem",
    centerPanelCategoryListItemNoCategoryHeader: "moduleScreens__centerPanelCategoryListItem--noCategoryHeader",
    centerPanelCategoryListItemHeader: "moduleScreens__centerPanelCategoryListItem--header",
    centerPanelCategoryText: "moduleScreens__centerPanelCategoryText",
    centerPanelCategoryTextExpanded: "moduleScreens__centerPanelCategoryText--expanded",
    rightPanel: "moduleScreens__rightPanel",
    rightPanelCategory: "moduleScreens__rightPanelCategory",
    rightPanelCategoryText: "moduleScreens__rightPanelCategoryText",
    rightPanelScreen: "moduleScreens__rightPanelScreen",
    rightPanelScreenSelected: "moduleScreens__rightPanelScreen--selected",
    rightPanelScreenText: "moduleScreens__rightPanelScreenText",
    moduleScreensNewWindowButton: "moduleScreens__newWindowButton",
    moduleScreensNewWindowButtonShown: "moduleScreens__newWindowButton--shown",
    portalButtonIcon: "portalButton__icon",

    // mobile
    mobileHeader: "mobileHeader",
    mobileBottomBar: "mobileBottomBar",
    mobileMenuButton: "mobileBottomBar__menuButton",
    mobileBackButton: "mobileBottomBar__backButton",
    mobileBackButtonDisabled: "mobileBarButton--disabled",
    mobileHomeButton: "mobileBottomBar__homeButton",
    mobileMessagesButton: "mobileBottomBar__messagesButton",
    mobileFriendlyName: "mobileHeader__friendlyName",
    mobileMenu: "skywardMainMenu",
    mobileMenuExpanded: "skywardMainMenu--expanded",
    moduleList: "skywardMainMenu__moduleList",
    messageCounter: "mobileBottomBar__userMessagesCounter",
    messageCounterVisible: "mobileBottomBar__userMessagesCounter--visible",
    mobileGlass: "glass",
    menuHomeButton: "menu-home-button",
    menuHomeButtonText: "menu-home-button-text",
    menuGroup: "menu-expand-group",
    menuGroupExpanded: "menu-expand-group--expanded",
    menuGroupBusy: "menu-expand-group--busy",
    menuGroupItem: "menu-expand-group__item",
    menuGroupItemHasMenu: "menu-expand-group__item--has-menu",
    menuGroupHeader: "menu-expand-group__header",
    menuGroupSvg: "menu-expand-group__svg",
    menuGroupTitle: "menu-expand-group__title",
    menuGroupLabel: "menu-expand-group__label",
    menuGroupChevron: "menu-expand-group__chevron",
    menuGroupSearch: "menu-expand-group--search",
    menuGroupSearchBox: "menu-expand-group--search-box",
    menuGroupSearchSvg: "menu-expand-group--search-svg",
    menuGroupSearchMessage: "menu-expand-group--search-message",
    menuGroupSearchClear: "menu-expand-group--search-clear",
    menuGroupSearchHasMessage: "menu-expand-group--search-has-message",
    menuGroupSearchItemHidden: "menu-expand-group--search-item-hidden",
    menuGroupUserMenu: "menu-expand-group--user-menu",
    menuGroupUserMenuHasDetails: "menu-expand-group--user-menu-has-details",
    menuGroupUserName: "menu-expand-group--user-name",
    menuGroupUserDetail: "menu-expand-group--user-detail",
    menuGroupSelectionMenu: "menu-expand-group--selection-menu",
    menuGroupSelectionTitle: "menu-expand-group--selection-title",
    menuGroupSelectionItem: "menu-expand-group--selection-item",
    menuGroupSelectionNoIndent: "menu-expand-group--no-indent",
    menuGroupPortalMenu: "menu-expand-group--portal-menu",
    menuGroupPortalUnsupported: "menu-expand-group--portal-unsupported",
    menuGroupModuleMenu: "menu-expand-group--module-menu",
    menuGroupForcedClosed: "menu-expand-group--forced-closed",

    // javascript only
    jsDesktopMenuVisibilityToggle: "js-skywardMainMenuVisibilityToggle",
    jsSetSelectedPortal: "js-setSelectedPortal",
    jsModuleClick: "js-skywardMainMenuModuleButtonClick",
    jsPortalButtonKeyboardCacheMarker: "js-portalButtonKeyboardCacheMarker",
    jsModuleButtonKeyboardCacheMarker: "js-moduleButtonKeyboardCacheMarker",
    jsScreenButtonKeyBoardCacheMarker: "js-moduleScreenButtonKeyboardCacheMarker",
    jsScreenButtonClick: "js-skywardMainMenuModuleScreenScreenClick",
    jsCenterPanelKeyboardCacheMarker: "js-skywardMainMenuCenterPanelKeyboardCacheMarker",
    jsRightPanelKeyboardCacheMarker: "js-skywardMainMenuRightPanelKeyboardCacheMarker",
    // portal code postfix appended by creating method
    jsPortalSpecificButtonMarker: "js-portalButtonForSpecificPortal--"
};